export enum NotificationStatus {
    EXITED_MATCH = 'EXITED_MATCH',
    EXITED_TOP_PICK = 'EXITED_TOP_PICK',
    MATCH = 'MATCH',
    NEW_OPPORTUNITY = 'NEW_OPPORTUNITY',
    PROFILE_CHANGED_BY_PH = 'PROFILE_CHANGED_BY_PH',
    REJECTED = 'REJECTED',
    TOP_PICK = 'TOP_PICK',
    VERIFIED = 'VERIFIED',
}